import { Grid } from "@idg-web-platform/pulse";
import { ComponentChildren } from "preact";
import SSI from "../../ssi.tsx";

interface NavigationWrapperProps {
  currentPath?: string;
  children: ComponentChildren;
}

export function NavigationWrapper(props: NavigationWrapperProps) {
  return (
    <Grid>
      <div className="double-1_3-left">
        <SSI url={`/fragments/c/accounts/navigation?currentPath=${props.currentPath}`} />
      </div>
      <div className="double-1_3-right">{props.children}</div>
    </Grid>
  );
}
